import { render, staticRenderFns } from "./ClockIndicator.vue?vue&type=template&id=ea38d634&"
import script from "./ClockIndicator.vue?vue&type=script&lang=js&"
export * from "./ClockIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports